import React from "react";
import EverestImage from "../images/everest.jpg"; // Ensure you have the Everest image in the correct path
import { FaArrowRight } from "react-icons/fa"; // For the right-arrow icon
import "../App.css"; // Import the CSS file

const Places = () => {
  const places = [
    "Phakding",
    "Lukla",
    "Namche Bazar",
    "Tengboche",
    "Pangboche",
    "Dingboche",
    "Lobuche",
    "Thuk La",
    "Gorakshep",
    "Everest Base Camp",
    "Khumbu Icefall",
    "Camp 1",
    "Western Cwm",
    "Camp 2",
    "Camp 3",
    "Geneva Spur",
    "South Col/Camp 4",
    "Balcony",
    "South Summit",
    "Hillary Step",
    "East Face",
    "Summit of Mt. Everest",
  ];

  // Divide the places into two columns
  const middleIndex = Math.ceil(places.length / 2);
  const leftPlaces = places.slice(0, middleIndex);
  const rightPlaces = places.slice(middleIndex);

  return (
    <div className="places-container">
      <h2 className="places-heading">Important Places In The Expedition</h2>
      <div className="places-content">
        {/* Left Column */}
        <ul className="places-list">
          {leftPlaces.map((place, index) => (
            <li key={index} className="places-item">
              <span className="places-badge">{place}</span>
            </li>
          ))}
        </ul>

        {/* Center Column with Image */}
        <div className="places-image-container">
          <img src={EverestImage} alt="Everest" className="places-image" />
          <a
            href="/The-Challenge-Of-Everest.pdf"
            className="places-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Know More About Places
            <br />
            <FaArrowRight className="places-icon" />
          </a>
        </div>

        {/* Right Column */}
        <ul className="places-list">
          {rightPlaces.map((place, index) => (
            <li key={index} className="places-item">
              <span className="places-badge">{place}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Places;
